import React from 'react'
import './style.styl'
import { Button } from '@driftt/tide-core-legacy'

const SuggestIntegration = ({onClick}) => (
            <div className='suggest-integration'>
                <hr className="suggest-integration-hr"></hr>
                <div>
                    <h3 className='suggest-integration-header'>Don't see what you're looking for? Let us know!</h3>
                </div>
                <div className='suggest-integration-button-holder'>
                    <div className='suggest-integration-paragraph-holder'>
                        <p className ='suggest-integration-paragraph'>Let our team know which integrations you’re looking for! You can also check out 
                        <a href="https://dev.drift.com"target="_blank"> Drift’s dev platform </a> 
                        to find ways to customize Drift to fit your team’s needs. </p>
                    </div>
                    <Button className='suggest-integration-button' onClick={onClick}> Suggest an integration</Button>
                </div>
            </div>
        
)
export default SuggestIntegration


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/SuggestIntegration/index.js